import React from "react";
import SamuraiShowdownSirCubworth from "assets/audio/SamuraiShowdownSirCubworth.mp3";
import { useMediaPlayerContext } from "hooks/useContextAll";

const MediaContainer = () => {
    const media = useMediaPlayerContext();

    return (
        <li className="accessories-item">
            <button className="header-btn" onClick={media.handlePlaying}>
                <ion-icon name={media.isPlaying ? "pause" : "play"}></ion-icon>
            </button>
            <div className="audio-box">
                <audio loop ref={media.audioRef}>
                    <source src={SamuraiShowdownSirCubworth} />
                </audio>
            </div>
        </li>
    );
};

export default MediaContainer;
